export default __webpack_public_path__ + "static/earth_specular_map-e09ac85c1b7affa900674f703a0c32e5.jpg";